import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { useGetCurrentUserId } from "../hooks/useGetCurrentUserId";
import { getStorage, ref as storageRef, listAll, getDownloadURL } from "firebase/storage";
import { Eye, Download, ArrowLeft, Info } from "lucide-react";
import "./UserProofOfDelivery.css";
import { useNavigate } from "react-router-dom";

const UserProofOfDelivery = () => {
  const { userId, loading } = useGetCurrentUserId();
  const [proofs, setProofs] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!userId) return;

    const db = getDatabase();
    const paymentRef = ref(db, "transport_payment");

    const unsubscribe = onValue(paymentRef, async (snapshot) => {
  if (!snapshot.exists()) {
    setProofs([]);
    return;
  }

  const data = snapshot.val();
  let allProofs = [];

  Object.keys(data).forEach((transporterId) => {
    const transporterProofs = data[transporterId];

    Object.keys(transporterProofs).forEach((key) => {
      const item = transporterProofs[key];

      if (item.clientId === userId) {
        allProofs.push({
          id: key,
          transporterId, // ✅ IMPORTANT
          ...item,
        });
      }
    });
  });

  // latest first
  allProofs.sort((a, b) => b.uploadedAt - a.uploadedAt);

  // 🔥 FETCH PHOTOS FROM STORAGE
  const storage = getStorage();

  const proofsWithPhotos = await Promise.all(
    allProofs.map(async (item) => {
      try {
        const photoFolderRef = storageRef(
          storage,
          `transport_payment/${item.transporterId}/photo`
        );

        const res = await listAll(photoFolderRef);

        if (res.items.length === 0) {
          return { ...item, photos: [] };
        }

        const photoUrls = await Promise.all(
          res.items.map((imgRef) => getDownloadURL(imgRef))
        );

        return {
          ...item,
          photos: photoUrls,
        };
      } catch (err) {
        return { ...item, photos: [] };
      }
    })
  );

  setProofs(proofsWithPhotos);
});

    return () => unsubscribe();
  }, [userId]);

  

  if (loading) return <p className="loading">Loading...</p>;

  return (
    <div className="pod-container">
      <div className="pod-header">

  {/* LEFT: Back */}
  <button className="pod-back-btn" onClick={() => navigate(-1)}>
    <ArrowLeft size={20} />Back
  </button>

  {/* CENTER: Title */}
  <h1 className="pod-title">Proof Of Delivery</h1>

  {/* RIGHT: Info */}
  <button className="pod-info-btn" onClick={() => setShowInfo(true)}>
    <Info size={20}/>
  </button>

</div>
{showInfo && (
  <div className="issue-overlay">
    <div className="issue-modal">
      
      <button
        className="issue-close"
        onClick={() => setShowInfo(false)}
      >
        ✕
      </button>

      <h3 className="mb-2">How This Work</h3>

      <ul>
        <li>View all uploaded delivery proofs</li>
        <li>Check truck and order details</li>
        <li>Download proof files</li>
        <li>Track delivery completion records</li>
      </ul>

    </div>
  </div>
)}

      {proofs.length === 0 ? (
        <p className="no-data">No proof uploaded yet.</p>
      ) : (
        <div className="pod-table-wrapper">
          <table className="pod-table">
            <thead>
              <tr>
                 <th>#</th>
                <th>Truck</th>
                <th>Order Id</th>
                <th>Route</th>
                <th>File</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {proofs.map((item,index) => (
                <tr key={item.id}>
                    <td>{index + 1}</td>
                  <td>{item.truckNumber}</td>
                  <td className="text-primary">{item.orderId}</td>
                  <td>{item.route}</td>
<td>
  <div className="file-list">

    {/* 🔥 MAIN FILE */}
    {item.fileUrl && (
      <a
        href={item.fileUrl}
        target="_blank"
        rel="noreferrer"
        className="file-item file-main"
      >
        <Download size={14} /> View
      </a>
    )}

    {/* 🔥 PHOTOS */}
    {item.photos && item.photos.length > 0 ? (
      item.photos.map((img, i) => (
        <a
          key={i}
          href={img}
          target="_blank"
          rel="noreferrer"
          className="file-item file-photo"
        >
          <Download size={14} /> View
        </a>
      ))
    ) : (
      !item.fileUrl && (
        <span className="no-file">No Files</span>
      )
    )}

  </div>
</td>


                  <td>
                    {new Date(item.uploadedAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
      )}
{/* MOBILE VIEW */}
<div className="pod-mobile">
  {proofs.map((item) => (
    <div key={item.id} className="pod-card">
      
      <div className="pod-card-row">
         <strong>Truck: {item.truckNumber}</strong>
      
      </div>
 <div className="pod-route">
         OrderId: <span className="text-primary">{item.orderId}</span>
      </div>
      <div className="pod-route">
        <b className="text-secondary">Route:</b> {item.route}
      </div>

     <div className="file-list">

  {/* 🔥 MAIN FILE */}
  {item.fileUrl && (
    <a
      href={item.fileUrl}
      target="_blank"
      rel="noreferrer"
      className="file-item file-main"
    >
      <Download size={14} /> View File
    </a>
  )}

  {/* 🔥 PHOTOS */}
  {item.photos && item.photos.length > 0 ? (
    item.photos.map((img, i) => (
      <a
        key={i}
        href={img}
        target="_blank"
        rel="noreferrer"
        className="file-item file-photo"
      >
        <Download size={14} /> View File
      </a>
    ))
  ) : (
    !item.fileUrl && (
      <span className="no-file">No Files</span>
    )
  )}

</div>

      <div className="pod-date">
        {new Date(item.uploadedAt).toLocaleString()}
      </div>

    </div>
  ))}
</div>
      
    </div>
  );
};

export default UserProofOfDelivery;